import { useFttxRoutes } from 'hooks/useFttxRoutes';

export const AppFttx = () => {
    const routes = useFttxRoutes();

    return <>{routes}</>;
};
